export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-2.7e242370.png";